import { render } from "./BuildingLevelDisplay.vue?vue&type=template&id=1a4bb7a8"
import script from "./BuildingLevelDisplay.vue?vue&type=script&lang=js"
export * from "./BuildingLevelDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__